import { Links } from './constants'

export const getAppLink = (applessOnly: boolean) =>
  applessOnly ? Links.APPLESS : Links.STORE

// will only work on simple paths. If you have https://..., it will break it by removing the double slashes
export const joinPath = (...paths: string[]) => {
  return paths.join('/')?.replace(/\/+/g, '/')
}
